// Общие типы, WS-протокол и WAV-утилиты Besedka (браузер + Node).
// ---------- Утилиты времени ----------
export function formatTimecode(totalSeconds) {
    const s = Math.max(0, Math.floor(totalSeconds));
    const h = Math.floor(s / 3600);
    const m = Math.floor((s % 3600) / 60);
    const r = s % 60;
    return [h, m, r].map((p) => String(p).padStart(2, '0')).join(':');
}
export function formatMs(ms) {
    return formatTimecode(ms / 1000);
}
// ---------- WAV (mono, 16-bit LE) ----------
export const WAV_HEADER_SIZE = 44;
/** Собирает 44-байтовый WAV-заголовок для mono/16-bit PCM. */
export function buildWavHeader(nSamples, sampleRate) {
    const dataSize = nSamples * 2;
    const buf = new ArrayBuffer(WAV_HEADER_SIZE);
    const v = new DataView(buf);
    const writeStr = (off, s) => {
        for (let i = 0; i < s.length; i++)
            v.setUint8(off + i, s.charCodeAt(i));
    };
    writeStr(0, 'RIFF');
    v.setUint32(4, 36 + dataSize, true);
    writeStr(8, 'WAVE');
    writeStr(12, 'fmt ');
    v.setUint32(16, 16, true); // fmt chunk size
    v.setUint16(20, 1, true); // PCM
    v.setUint16(22, 1, true); // mono
    v.setUint32(24, sampleRate, true);
    v.setUint32(28, sampleRate * 2, true); // byte rate
    v.setUint16(32, 2, true); // block align
    v.setUint16(34, 16, true); // bits per sample
    writeStr(36, 'data');
    v.setUint32(40, dataSize, true);
    return buf;
}
/** Парсит WAV-заголовок (ищет data-чанк, устойчив к дополнительным чанкам). */
export function parseWavHeader(bytes) {
    const v = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
    const str = (off, len) => String.fromCharCode(...bytes.subarray(off, off + len));
    if (str(0, 4) !== 'RIFF' || str(8, 4) !== 'WAVE')
        throw new Error('Not a WAV file');
    let off = 12;
    let sampleRate = 0;
    let channels = 0;
    let bitsPerSample = 0;
    while (off + 8 <= bytes.byteLength) {
        const id = str(off, 4);
        const size = v.getUint32(off + 4, true);
        if (id === 'fmt ') {
            channels = v.getUint16(off + 10, true);
            sampleRate = v.getUint32(off + 12, true);
            bitsPerSample = v.getUint16(off + 22, true);
        }
        else if (id === 'data') {
            return { sampleRate, channels, bitsPerSample, dataOffset: off + 8, dataSize: size };
        }
        off += 8 + size + (size % 2);
    }
    throw new Error('WAV data chunk not found');
}
/** Float32 [-1..1] → Int16 PCM. */
export function floatTo16(input, out) {
    const result = out ?? new Int16Array(input.length);
    for (let i = 0; i < input.length; i++) {
        const s = Math.max(-1, Math.min(1, input[i]));
        result[i] = s < 0 ? s * 0x8000 : s * 0x7fff;
    }
    return result;
}
// ---------- Разное ----------
export function normalizeUrlLoose(raw) {
    const value = String(raw || '').trim();
    if (!value)
        return '';
    const url = new URL(value.startsWith('http://') || value.startsWith('https://') ? value : `https://${value}`);
    url.hash = '';
    url.hostname = url.hostname.toLowerCase();
    if (url.pathname !== '/')
        url.pathname = url.pathname.replace(/\/+$/, '');
    return url.toString();
}
export const CHUNK_SECONDS = 5;
export const HEARTBEAT_INTERVAL_MS = 2000;
export const VERIFIED_TAIL_KEEP = 24; // сколько последних verified-чанков держать в IndexedDB
//# sourceMappingURL=index.js.map